import { render, staticRenderFns } from "./FeesReceived.vue?vue&type=template&id=2394cc39&scoped=true&"
import script from "./FeesReceived.vue?vue&type=script&lang=js&"
export * from "./FeesReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394cc39",
  null
  
)

export default component.exports